// src/stores/announcementStore.js
import { defineStore } from "pinia";
import { announcementsService } from "@/services/announcementsService";

export const useAnnouncementStore = defineStore("announcementStore", {
  state: () => ({
    announcements: [], // List of announcements
    selectedAnnouncement: null, // currently selected announcement
  }),

  actions: {
    // Fetches all announcements from the API and updates the state.
    async getAllAnnouncements() {
      try {
        const response = await announcementsService.fetchAllAnnouncements();
        this.announcements = response.data;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
        throw error;
      }
    },

    // Fetches announcements for a specific state and optional filters.
    async getAllStateAnnouncement(state, queryParams) {
      try {
        const response = await announcementsService.fetchAllStateAnnouncements(state, queryParams);
        this.announcements = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch state announcements:`, error);
        throw error;
      }
    },

    // Fetches a specific announcement by its ID.
    async getAnnouncementById(announcementId) {
      try {
        const response = await announcementsService.fetchAnnouncements(announcementId);
        this.selectedAnnouncement = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch announcement with ID: ${announcementId}`, error);
        throw error;
      }
    },

    // Creates a new announcement.
    async createAnnouncement(announcementData) {
      try {
        const response = await announcementsService.store(announcementData);
        this.announcements.push(response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to create announcement:", error);
        throw error;
      }
    },

    // Updates an existing announcement.
    async updateAnnouncement(announcementId, announcementData) {
      try {
        const response = await announcementsService.update(announcementId, announcementData);
        const index = this.announcements.findIndex((a) => a.id === announcementId);
        if (index !== -1) {
          this.announcements[index] = response.data; // Update the specific announcement in the state
        }
        return response.data;
      } catch (error) {
        console.error(`Failed to update announcement with ID: ${announcementId}`, error);
        throw error;
      }
    },

    // Deletes an announcement and removes it from the state
    async deleteAnnouncement(announcementId) {
      try {
        await announcementsService.delete(announcementId);
        this.announcements = this.announcements.filter((a) => a.id !== announcementId);
      } catch (error) {
        console.error(`Failed to delete announcement with ID: ${announcementId}`, error);
        throw error;
      }
    },

    /**
     * Clears the selected announcement from the state.
     */
    clearSelectedAnnouncement() {
      this.selectedAnnouncement = null;
    },
  },
});
